/** @format */
import { BrowserRouter as Router, useLocation } from "react-router-dom";
import "./App.css";

import AppRoutes from "./routes/routes";
import NavHeader from "./components/common/NavHeader";
import Header from "./components/common/Header";
import Sidebar from "./components/common/Sidebar";
import Footer from "./components/common/Footer";
import { ToastContainer } from "react-toastify";
import 'react-toastify/dist/ReactToastify.css';
function Layout({ children }) {
  const location = useLocation();
  return (
    <div id="main-wrapper">
      <ToastContainer position="top-right" />
      {location.pathname !== "/login" && (
        <>
          {" "}
          <NavHeader />
          <Header /> <Sidebar />
        </>
      )}

      {location.pathname === "/login" ? children : (
        <div className="content-body">
          <div className="container-fluid">{children}</div>
        </div>
      )}

      {location.pathname !== "/login" && <Footer />}
    </div>
  );
}

function App() {

  // useEffect(() => {
  //   const interval = setInterval(() => {
  //         window.location.reload(); // Refresh the page
  //     }, 5 * 60 * 1000); // 5 minutes in milliseconds

  //     return () => clearInterval(interval); // Cleanup interval on component unmount
  // }, []);

  return (
    <Router basename="/">
      {/********************
  Preloader start
    *********************/}
      <div id="preloader">
        {/* <div>
          <img src="images/pre.gif" alt="" />
        </div> */}
      </div>
      <Layout>
        <AppRoutes />
      </Layout>
    </Router>
  );
}

export default App;
